import auth from '../api/auth';
// import session from '../api/session';
import {
    LOGIN_BEGIN,
    LOGIN_FAILURE,
    LOGIN_SUCCESS,
    LOGOUT,
    REMOVE_TOKEN,
    // SET_LOGGED_IN,
    SET_TOKEN,
} from './types';

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY';
const isProduction = process.env.NODE_ENV === 'production';

const initialState = {
    loadingApp: true,
    authenticating: false,
    error: false,
    token: null,
    loggedIn: false,
    userIsSuperUser: false,
};

const getters = {
    isAuthenticated: state => state.loggedIn,
};

const actions = {
    login({ commit }, { username, password }) {
        commit(LOGIN_BEGIN);
        return auth.login(username, password)
            .then(({ data }) => commit(SET_TOKEN, data.key))
            .then(() => commit(LOGIN_SUCCESS))
            .catch(() => commit(LOGIN_FAILURE));
    },
    logout({ commit }) {
        return auth.logout()
            .then(() => commit(LOGOUT))
            .finally(() => commit(REMOVE_TOKEN));
    },
    initialize({ commit }) {
        const token = localStorage.getItem(TOKEN_STORAGE_KEY);

        if (isProduction && token) {
            commit(REMOVE_TOKEN);
        }

        if (!isProduction && token) {
            commit(SET_TOKEN, token);
        }
    },
};

const mutations = {
    // [LOGIN_BEGIN](state) {
    //     state.authenticating = true;
    //     state.error = false;
    // },
    // [LOGIN_FAILURE](state) {
    //     state.authenticating = false;
    //     state.error = true;
    // },
    // [LOGIN_SUCCESS](state) {
    //     state.authenticating = false;
    //     state.error = false;
    // },
    // [LOGOUT](state) {
    //     state.authenticating = false;
    //     state.error = false;
    // },
    // [SET_TOKEN](state, token) {
    //     if (!isProduction) localStorage.setItem(TOKEN_STORAGE_KEY, token);
    //     session.defaults.headers.Authorization = `Token ${token}`;
    //     state.token = token;
    // },
    // [REMOVE_TOKEN](state) {
    //     localStorage.removeItem(TOKEN_STORAGE_KEY);
    //     delete session.defaults.headers.Authorization;
    //     state.token = null;
    // },
    // [SET_LOGGED_IN](state, is_logged_in) {
    //     alert("Did set logged in");
    //     if (!isProduction) localStorage.setItem(SET_LOGGED_IN, is_logged_in);
    //     state.logged_in = is_logged_in;
    // },
    loginBegin(state) {
        state.authenticating = true;
        state.error = false;
    },
    loginFailure(state) {
        state.authenticating = false;
        state.error = true;
    },
    loginSuccess(state) {
        state.authenticating = false;
        state.error = false;
        if (!isProduction) localStorage.setItem('setLoggedIn', true);
        state.loggedIn = true;
    },
    logOut(state) {
        state.loggedIn = false;
        state.authenticating = false;
        state.error = false;
    },
    setLoggedIn (state, payload) {
        if (!isProduction) localStorage.setItem('setLoggedIn', payload);
        state.loggedIn = payload;
    },
    setLoadingApp (state, payload) {
        state.loadingApp = payload;
    },
    setUserIsSuperUser (state, payload) {
        state.userIsSuperUser = payload;
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};